/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ maxCps: NonNullable<unknown> }} Summary_Max_Cps_TitleInputs */

const en_summary_max_cps_title = /** @type {(inputs: Summary_Max_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Max CPS: ${i?.maxCps}`)
};

const fr_summary_max_cps_title = /** @type {(inputs: Summary_Max_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CPS Max: ${i?.maxCps}`)
};

const de_summary_max_cps_title = /** @type {(inputs: Summary_Max_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Max CPS: ${i?.maxCps}`)
};

const it_summary_max_cps_title = /** @type {(inputs: Summary_Max_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CPS massimo: ${i?.maxCps}`)
};

const ru_summary_max_cps_title = /** @type {(inputs: Summary_Max_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Максимальное количество CPS: ${i?.maxCps}`)
};

const es_summary_max_cps_title = /** @type {(inputs: Summary_Max_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CPS máximo: ${i?.maxCps}`)
};

const zh_cn2_summary_max_cps_title = /** @type {(inputs: Summary_Max_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最大 CPS：${i?.maxCps}`)
};

const ja_summary_max_cps_title = /** @type {(inputs: Summary_Max_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最大CPS: ${i?.maxCps}`)
};

const hi_summary_max_cps_title = /** @type {(inputs: Summary_Max_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`अधिकतम सीपीएस: __पीएच_0__`)
};

const pt_pt2_summary_max_cps_title = /** @type {(inputs: Summary_Max_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CPS máximo: ${i?.maxCps}`)
};

/**
* | output |
* | --- |
* | "Max CPS: {maxCps}" |
*
* @param {Summary_Max_Cps_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const summary_max_cps_title = /** @type {((inputs: Summary_Max_Cps_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summary_Max_Cps_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_summary_max_cps_title(inputs)
	if (locale === "de") return de_summary_max_cps_title(inputs)
	if (locale === "it") return it_summary_max_cps_title(inputs)
	if (locale === "ru") return ru_summary_max_cps_title(inputs)
	if (locale === "es") return es_summary_max_cps_title(inputs)
	if (locale === "zh-CN") return zh_cn2_summary_max_cps_title(inputs)
	if (locale === "ja") return ja_summary_max_cps_title(inputs)
	if (locale === "hi") return hi_summary_max_cps_title(inputs)
	if (locale === "pt-PT") return pt_pt2_summary_max_cps_title(inputs)
	return en_summary_max_cps_title(inputs)
});